import { Image } from '@/shared/ui/Image'

import { CDN_SPLIT_IMG_URL } from '../../data'

import cls from './style.module.scss'

const noteText = `Базовый Сплит на 2 месяца — без переплат. Выберите товар, а затем оплату частями в сплит. Заплатите четверть цены и сразу заберите покупку. Остальные части спишутся позже — по комфортному графику`

export const SplitWork = () => (
	<div>
		<div className={cls.splitWork__content}>
			<p className={cls.splitWork__title}>Сплитуйте без переплат</p>
			<p className={cls.splitWork__subtitle}>Делите стоимость любой покупки на несколько платежей</p>
			<div className={cls.splitWork__imgWrap}>
				<Image width={1368} height={208} src={`${CDN_SPLIT_IMG_URL}/splitWorkDesc.png`} alt="" />
				<Image width={563} height={322} src={`${CDN_SPLIT_IMG_URL}/splitWorkTablet.png`} alt="" />
				<Image width={313} height={218} src={`${CDN_SPLIT_IMG_URL}/splitWorkMobile.png`} alt="" />
			</div>
		</div>
		<p className={cls.note}>{noteText}</p>
	</div>
)
